import {  useState } from "react";

import { Title } from "../../../../stories/Title/Title";
import { Button } from "../../../../stories/Button/Button";
import Close from "../../../../images/Close.svg";
import { CustomModal } from "../../../../utils/UtilFunctions";
import { CustomModalStyles } from "../../../../styles/CustomModalStyles";
import AddCustomer from "../AddCustomer";
import { Operation, PageFor } from "../../../../utils/Enum.types";
import { modalOpertaionFlag } from "../Index";
import FinancialYear from "../financialYear/Index";
import CustomerUsers from "../users/Index";
import AssetConfiguration from "../../asset/configurations/AssetConfiguration";
import { SwConfigQueryType } from "../../asset/masters/items/configurations/queries/type";

interface props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface CustomModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  contentComponent: React.ReactNode;
}

const EditCustomerModal = ({ setModalFlag }: props) => {
  const [customerDetails, setCustomerDetails] = useState<modalOpertaionFlag>({
    flag: false,
    operation: Operation.CREATE,
  });
  const [financialYear, setFinancialYear] = useState(false);
  const [addUserData, setAddUserData] = useState<modalOpertaionFlag>({
    flag: false,
    operation: Operation.CREATE,
  });
  const [customerRights, setCustomerRights] = useState<modalOpertaionFlag>({
    flag: false,
    operation: Operation.CREATE,
  });

  return (
    <>
      <div className="subsidary__edit">
        <div className="subsidary__edit--title">
          <Title variant="subtitle1">Choose a Section to Edit</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="subsidary__edit--tabs">
          <button
            onClick={() => {
              setCustomerDetails({
                flag: true,
                operation: Operation.UPDATE,
              });
            }}
          >
            Customer Details
          </button>
          <button
            onClick={() => {
              setFinancialYear(true);
            }}
          >
            Financial Year
          </button>
          <button
            onClick={() => {
              setCustomerRights({
                flag: true,
                operation: Operation.UPDATE,
              });
            }}
          >
            Customer Rights
          </button>
          <button
            onClick={() => {
              setAddUserData({
                flag: true,
                operation: Operation.UPDATE,
              });
            }}
          >
            User Details
          </button>
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>

      <CustomModal
        isOpen={customerDetails.flag}
        onRequestClose={() =>
          setCustomerDetails({
            flag: !customerDetails.flag,
            operation: Operation.NONE,
          })
        }
        contentComponent={
          <AddCustomer
            setModalFlag={setCustomerDetails}
            operation={Operation.UPDATE}
          />
        }
        style={CustomModalStyles}
      />

      <CustomModal
        isOpen={financialYear}
        onRequestClose={() => setFinancialYear(!financialYear)}
        contentComponent={
          <FinancialYear
            operation={Operation.UPDATE}
            setModal={setFinancialYear}
            steps={false}
          />
        }
        style={CustomModalStyles}
      />

      <CustomModal
        isOpen={customerRights.flag}
        onRequestClose={() =>
          setCustomerRights({
            flag: !customerRights.flag,
            operation: Operation.NONE,
          })
        }
        contentComponent={
          <AssetConfiguration
            setModalFlag={setCustomerRights}
            pageType={PageFor.MODAL}
            queryType={SwConfigQueryType.EDUATE_COMPLETE_CONFIG}
          />
        }
        style={CustomModalStyles}
      />

      <CustomModal
        isOpen={addUserData.flag}
        onRequestClose={() =>
          setAddUserData({
            flag: !addUserData.flag,
            operation: Operation.NONE,
          })
        }
        contentComponent={
          <CustomerUsers
            setModalFlag={setAddUserData}
            pageType={PageFor.MODAL}
          />
        }
        style={CustomModalStyles}
      />
    </>
  );
};

export default EditCustomerModal;
